import script from "./ElementTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./ElementTooltip.vue?vue&type=style&index=0&id=1e0ddbaa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0ddbaa"]])

export default __exports__